import {UploadDisplay} from "../components/bestAvailable/UploadDisplay"
import { DataSetSelect } from "../components/bestAvailable/DataSetSelect";
import {DisplayTable} from "../components/bestAvailable/DisplayTable"
import {logo} from '../assets'

export const BestAvailable = () => {
    return (
        <div style={{ textAlign: "center" }}>
            <div className="is-flex is-justify-content-center is-flex-direction-column is-align-items-center">
                <img src={logo} alt="Dynasty Dugout Logo" style={{objectFit: "cover", height: "25%", width:"auto", maxHeight: "200px"}} />
            </div>
            <div className="is-flex is-justify-content-center is-flex-direction-column is-align-items-center">
                <h1 style={{fontSize: "2.5rem", marginTop: "0", marginBottom: "1rem", fontWeight: "bold"}}>
                    Best Available
                </h1>
            </div>
            <div>
            Instructions:
            <br/>
            <div style={{fontSize: ".8rem", marginLeft: "3rem", marginRight: "3rem", marginBottom: "1rem"}}>
            Go to Fantrax, then click the players tab. From there change the “Status” to “All Taken Players.”
            <br/>
            Download the CSV file. Click the Upload CSV file on the app and choose the download from Fantrax. Click Import and Chris’s rankings will automatically filter. 
            </div>
            </div>
            <UploadDisplay />
            <DataSetSelect />
            <div className="is-flex is-justify-content-center is-flex-direction-column is-align-items-center">
            <DisplayTable />
            </div>
            
        </div>
      );
}